import React from 'react';
import Button from '@atlaskit/button';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import useAddGroupTemplate from '../../controllers/add-group-template/index.tsx';
import messages from './messages';
import { ActionsWrapper } from './styled';

const PageHeader = () => {
	const { formatMessage } = useIntl();
	const showGroupTemplate = useAddGroupTemplate();

	return (
		<div>
			<p>{formatMessage(messages.explanationText)}</p>
			<ActionsWrapper>
				<Button
					testId="servicedesk-portal-settings-request-groups.ui.page-header.create-group"
					onClick={(_, analyticsEvent) => {
						fireUIAnalytics(analyticsEvent, 'createGroup');
						showGroupTemplate();
					}}
				>
					{formatMessage(messages.createGroupButton)}
				</Button>
			</ActionsWrapper>
		</div>
	);
};

export default PageHeader;
